export default __webpack_public_path__ + "static/media/guia-4-1.287b39db.svg";